// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"b725db29","185":"27d7066f","338":"0fb2c9b0","442":"1ee38a08","541":"28770d2b","544":"00862d28","576":"6829cd9a","753":"cb40a587","775":"fbac13c3","776":"d6e86e08","778":"c946fc6d","823":"9f525883","916":"aead4f0c","990":"c0e990ad"}[chunkId] + ".js";
};